import { useAuth0 } from "@auth0/auth0-react";
import { useQuery } from "@tanstack/react-query";
import { QueryKeys } from "../utils";
import request from "@/lib/api/handler";
import { DraftJobOpeningDescription } from "@/types";

export const useOpportunitiesDraftJobDescriptionsQuery = (id?: string) => {
  const { getAccessTokenSilently } = useAuth0();

  const { isLoading, data, error } = useQuery({
    queryKey: QueryKeys.companyDraftJobDescriptions(id ?? ""),
    staleTime: Infinity,
    refetchOnWindowFocus: false,
    enabled: !!id,
    queryFn: async () => {
      const token = await getAccessTokenSilently();
      return request<DraftJobOpeningDescription[]>({
        method: "GET",
        path: `/api/jobOpening/${id}/draft_job_descriptions`,
        token,
      });
    },
  });

  return {
    draftJobDescriptionsLoading: isLoading,
    draftJobDescriptions: data ?? null,
    draftJobDescriptionsError: error ?? null,
  };
};
